import { FactureService } from "../services/factures/factureService";
import { BACKEND_URL } from "../config/api";

/**
 * Télécharge le fichier original d'une facture.
 * Retourne false si la facture n'a pas de fichier ; lève une erreur si l'API échoue.
 */
export const downloadFactureFile = async (factureId: string, numero: string): Promise<boolean> => {
  let fileUrl: string | undefined = await FactureService.downloadFacture(factureId);
  if (!fileUrl) return false;

  if (fileUrl.startsWith("/")) {
    fileUrl = `${BACKEND_URL}${fileUrl}`;
  }

  try {
    // Téléchargement via blob pour forcer l'enregistrement du fichier
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const filename = fileUrl.split("?")[0].split("/").pop() || `facture-${numero}.pdf`;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (fetchError) {
    console.warn("Fetch blob failed (likely CORS), falling back to window.open", fetchError);
    window.open(fileUrl, "_blank");
  }
  return true;
};
